// Banka Hareket Raporu kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.bankTransactionReport';

export const bankTransactionReportGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Banka Hareket Raporu nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tüm banka hesaplarınızdaki para giriş ve çıkışlarını tek listede görür, süzer, dışa aktarır ve gerekirse hatalı kaydı silersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    actions: t(`${G}.regions.actions`, 'Filtre / Loglar / Excel'),
    totals: t(`${G}.regions.totals`, 'Genel Toplam'),
    table: t(`${G}.regions.table`, 'Hareket listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu rapor ne gösterir?'),
      text: t(`${G}.s1.text`, 'Para yatırma, para çekme, transfer, tahsilat ve hızlı satış gibi tüm banka hareketleri en yeniden eskiye doğru listelenir. Sol üstteki geri bağlantısı sizi Banka sayfasına (Raporlar ekranından geldiyseniz Raporlar\'a) döndürür.'),
    },
    {
      region: 'actions',
      title: t(`${G}.s2.title`, '2. Filtreler, Loglar ve Excel'),
      text: t(`${G}.s2.text`, 'Filtreler ilk açılışta gizlidir; "Filtreleri Göster" ile açın. "Loglar" silinen banka işlemlerini kimin, ne zaman ve hangi sebeple sildiğini gösterir. "Excel İndir" listeyi dosyaya aktarır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Excel\'e yalnız ekranda açık olan sayfadaki satırlar aktarılır. Hepsini almak için sayfa başına satır sayısını büyütün.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Hareketleri süzün'),
      text: t(`${G}.s3.text`, 'İşlem Ara kutusu, Banka Hesabı, Satış Ekranı (birden çok seçilebilir), İşlem Tipi ve Başlangıç / Bitiş Tarihi alanlarıyla listeyi daraltın. Tarih alanlarında saat de seçebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'İşlem Tipi seçenekleri: Tüm İşlemler, Para Yatırma, Para Çekme, Havale/EFT.'),
        t(`${G}.s3.tip2`, 'Tarih boş bırakılırsa tarih sınırı uygulanmaz.'),
        t(`${G}.s3.tip3`, 'Bir filtreyi değiştirdiğinizde liste ilk sayfaya döner.'),
      ],
    },
    {
      region: 'totals',
      title: t(`${G}.s4.title`, '4. Genel Toplamı doğru okuyun'),
      text: t(`${G}.s4.text`, 'GENEL TOPLAM, ekrandaki sayfada listelenen TL (₺) hareketlerinin net tutarıdır: Para Çekme ve Ödeme hareketleri düşülür, diğerleri eklenir. Döviz hareketleri bu toplama girmez.'),
      tips: [
        t(`${G}.s4.tip1`, 'Bu tutar bir hesabın bakiyesi değildir. Hesapların güncel bakiyesini Banka sayfasında görürsünüz.'),
        t(`${G}.s4.tip2`, 'Seçtiğiniz dönemin tamamını görmek için tüm hareketler tek sayfaya sığacak kadar satır seçin.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Satırları ve ayrıntıyı inceleyin'),
      text: t(`${G}.s5.text`, 'Her satırda tarih ve saat, banka / hesap, işlem tipi, ödeme yöntemi, satış ekranı, açıklama (varsa belge no) ve tutar görünür. Kırmızı tutar çıkış, yeşil tutar giriştir. Alt hesap hareketlerinde hesap adının yanında "(Alt Hesap)" yazar. Göz simgesi (Detay) kaydın tüm bilgilerini açar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Hatalı hareketi silin'),
      text: t(`${G}.s6.text`, 'Satırdaki ⋮ düğmesinden "Sil"i seçin. Silinen kayıt Loglar\'da saklanır; silme geri alınamaz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Para Yatırma ve Para Çekme hareketi silindiğinde banka bakiyesi ters işlemle düzeltilir.'),
        t(`${G}.s6.tip2`, 'Fatura veya hızlı satıştan gelen hareketler buradan silinemez; "Fatura Yönetimine Git" ile ilgili faturayı silin.'),
        t(`${G}.s6.tip3`, 'Kredi taksit ödemesi ve kredi kullandırım hareketleri de buradan silinemez; Krediler bölümünden yönetilir.'),
        t(`${G}.s6.tip4`, 'Transfer ve alt hesap hareketlerinde silme bakiyeyi kendiliğinden düzeltmeyebilir; silmeden önce bakiyeyi kontrol edin, gerekirse ters yönde yeni bir işlem yapın.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Alttaki sayfalama ile ilerleyin; sayfa başına 25\'ten 2000\'e kadar satır seçebilirsiniz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
